import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { LanguageWrapper } from '@/components/LanguageWrapper'
import { defaultLanguage } from '@/i18n'

// Pages
import { HomePage } from '@/pages/HomePage'
import { ChiSiamoPage } from '@/pages/About/ChiSiamoPage'
import { SectorsPage } from '@/pages/SectorsPage'
import { ProcessesPage } from '@/pages/ProcessesPage'
import { NewsListPage } from '@/pages/News/NewsListPage'
import { NewsDetailPage } from '@/pages/News/NewsDetailPage'
import { ContactPage } from '@/pages/ContactPage'
import { CareersPage } from '@/pages/CareersPage'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage'
import { CookiePolicyPage } from '@/pages/CookiePolicyPage'

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />
      <Route path="/:lang" element={<LanguageWrapper />}>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="chi-siamo" element={<ChiSiamoPage />} />
          <Route path="about" element={<ChiSiamoPage />} />
          <Route path="fg-il-percorso" element={<Navigate to="/chi-siamo" replace />} />
          <Route path="about/our-journey" element={<Navigate to="/about" replace />} />
          <Route path="certificazioni" element={<Navigate to="/chi-siamo" replace />} />
          <Route path="about/certifications" element={<Navigate to="/about" replace />} />
          <Route path="partnership" element={<Navigate to="/chi-siamo" replace />} />
          <Route path="about/partnerships" element={<Navigate to="/about" replace />} />
          <Route path="settori" element={<SectorsPage />} />
          <Route path="sectors" element={<SectorsPage />} />
          <Route path="automazione-industriale" element={<SectorsPage />} />
          <Route path="sectors/industrial-automation" element={<SectorsPage />} />
          <Route path="intelligenza-artificiale-e-sistemi-di-visione" element={<SectorsPage />} />
          <Route path="sectors/ai-vision-systems" element={<SectorsPage />} />
          <Route path="distribuzione-industriale" element={<SectorsPage />} />
          <Route path="sectors/industrial-distribution" element={<SectorsPage />} />
          <Route path="settore-terziario" element={<SectorsPage />} />
          <Route path="sectors/tertiary-sector" element={<SectorsPage />} />
          <Route path="energie-rinnovabili" element={<SectorsPage />} />
          <Route path="sectors/renewable-energy" element={<SectorsPage />} />
          <Route path="processi" element={<ProcessesPage />} />
          <Route path="processes" element={<ProcessesPage />} />
          <Route path="progettazione" element={<Navigate to="/it/processi" replace />} />
          <Route path="processes/design" element={<Navigate to="/en/processes" replace />} />
          <Route path="realizzazione" element={<Navigate to="/it/processi" replace />} />
          <Route path="processes/manufacturing" element={<Navigate to="/en/processes" replace />} />
          <Route path="finale" element={<Navigate to="/it/processi" replace />} />
          <Route path="processes/final-stage" element={<Navigate to="/en/processes" replace />} />
          <Route path="news" element={<NewsListPage />} />
          <Route path="news/:slug" element={<NewsDetailPage />} />
          <Route path="contatti" element={<ContactPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="lavora-con-noi" element={<CareersPage />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
          <Route path="cookie-policy" element={<CookiePolicyPage />} />
          <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace />} />
    </Routes>
  )
}

export default function App() {
  return <AppRoutes />
}
